<template>
  <div class="d-flex flex-wrap">
    <h2 class="col-3 mb-4">{{ $t('autocaller_v2.monitoring.operators.topic') }}</h2>
    <colors-map :colors="operators_сolors" />
    <div class="col-12">
      <operators-name :operators="operators" />
    </div>
  </div>
</template>

<script>
  import ColorsMap from './monitoring-colors-map';
  import OperatorsName from './monitoring-name-operators'
  export default {
    components: {
      ColorsMap,
      OperatorsName
    },
    props: {
      operators: {
        type: [Array, String],
        default: () => []
      } 
    },
    computed: {
      operators_сolors() {
        return [
          {
            name: this.$t('autocaller_v2.monitoring.operators.disconnected.state'),
            state: 'disconnected'
          },
          {
            name: this.$t('autocaller_v2.monitoring.operators.connected.state'),
            state: 'active'
          }
        ]
      }
    }
  }
</script>